import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { SHELL_COLUMN_HEADER_CLASS } from '@/lib/shell-chrome'

export type ShellColumnHeaderProps = {
  title: ReactNode
  backSlot?: ReactNode
  primaryAction?: ReactNode
  /** Options menu, or the column's own ShellPanelToggle (agent cap). */
  optionsMenu?: ReactNode
  className?: string
  'data-testid'?: string
}

/**
 * The 40px column header line: back + title + primary "+" + options menu.
 * The sidebar mode title, the tab bar, and the agent cap share it.
 * Gallery: /?test=maater-ui#panel-collapse
 */
export function ShellColumnHeader({
  title,
  backSlot,
  primaryAction,
  optionsMenu,
  className,
  'data-testid': testId,
}: ShellColumnHeaderProps) {
  return (
    <div
      className={cn(
        SHELL_COLUMN_HEADER_CLASS,
        // No opaque fill: bg-sidebar here covers the sidebar's inset hover edge,
        // so this row's right border reads thinner than the sections around it.
        'flex w-full items-center gap-2 min-w-0 px-3 border-b border-border shrink-0',
        className,
      )}
      data-testid={testId}
    >
      {backSlot}
      <div className="text-sm font-semibold text-sidebar-foreground flex-1 min-w-0 truncate">
        {title}
      </div>
      {primaryAction ? (
        <div className="flex-none shrink-0">{primaryAction}</div>
      ) : null}
      {optionsMenu ? (
        <div className="flex-none shrink-0">{optionsMenu}</div>
      ) : null}
    </div>
  )
}
